import { Outlet } from 'react-router-dom';

export default function ServicesLayout() {
    return (
        <div className="max-w-3xl mx-auto p-6 space-y-6 bg-white dark:bg-gray-900 text-gray-900 dark:text-white rounded-lg shadow">
            <h1 className="text-3xl font-bold text-center">Our Services</h1>
            <Outlet />
        </div>
    );
}
